import invariant from 'invariant';

import { LocationField } from '#/components/Form/LocationField';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  values: {
    salaryBasedOn?: string;
    remoteStatus?: string;
    workCityStateUnified?: string;
  };
  handlePlaceDetails?: (
    place: google.maps.GeocoderResult,
    isEmployer: boolean,
  ) => void;
  updateValueWith?: (
    arg0: string | string[],
    arg1: (arg0: Record<string, unknown>) => unknown,
  ) => void;
};

export function WorkCityStateUnified({
  values,
  handlePlaceDetails,
  updateValueWith,
}: Props) {
  const { i18n } = useI18n();

  let label;
  if (values.remoteStatus === 'ONSITE') {
    label = `${i18n('Location')}*`;
  } else if (values.salaryBasedOn === 'EMPLOYER_LOCATION') {
    label = i18n('Select the location where the work was performed');
  } else if (values.salaryBasedOn === 'OWN_LOCATION') {
    label = `${i18n('Select the location where the work was performed')}*`;
  }
  invariant(label, 'Label has no value');

  return (
    <LocationField
      name="workCityStateUnified"
      addressTypes={['locality']}
      handlePlaceDetails={(place) => {
        // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        handlePlaceDetails(place, false);
      }}
      label={label}
      noWrap
      placeholder={i18n('e.g. Hawkins, IN')}
      includedRegionCodes={['US']}
      customErrorMatch={(errors) => errors.workStateCode}
      locationText={values.workCityStateUnified}
      onClear={() =>
        // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        updateValueWith(
          ['workCity', 'workStateCode', 'workLatitude', 'workLongitude'],
          () => ({
            workCity: null,
            workStateCode: null,
            workLatitude: null,
            workLongitude: null,
          }),
        )
      }
    />
  );
}
